import { FullWidthContent, MainMenuLayout } from '@layouts';
import { SelectCustomerCard } from '@organisms';
import List from './modules/List';
import useCustomersByProduct from '../namelessCards/data/useCustomersByProduct';

/** Nameless cards bulk list screen */
const NamelessCardsListScreen = () => {
  const { data } = useCustomersByProduct({ product: 'GiftCard' });

  return (
    <MainMenuLayout>
      <FullWidthContent>
        <SelectCustomerCard customOptions={data} />
        <List />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default NamelessCardsListScreen;
